module.exports = __webpack_public_path__ + "images/icons/icon-video-player-play-fed3715d.svg";